module.exports = __webpack_public_path__ + "images/sprites/ui/headline_icon_og_1220f9fcd5f4b14cb97d78c29e40dccb.png";